import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AiOutlineWarning } from "react-icons/ai";

import ConfirmationModal from "../../Dialogs/ConfirmationModal";
import { Color } from "../../Form/Button";
import useStyles from "./styles";

export interface SendBookingFileConfirmationModalHandles {
  open: (bookingIds: number[]) => void;
  close: () => void;
}
interface SendBookingFileConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: (bookingIds: number[]) => void;
  loadingAction?: boolean;
}

const SendBookingFileConfirmationModal: ForwardRefRenderFunction<
  SendBookingFileConfirmationModalHandles,
  SendBookingFileConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [bookingIds, setBookingIds] = useState<number[]>([]);

  const open = useCallback((bookingIds: number[]) => {
    setOpenModal(true);
    setBookingIds(bookingIds);
  }, []);

  const close = useCallback(() => {
    setOpenModal(false);
    setBookingIds([]);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <ConfirmationModal
      width="520px !important"
      open={openModal}
      closeModal={() => {
        if (closeModal) closeModal();
        close();
      }}
      type="warning"
      title={`${translate("resubmitToMODS")}`}
      leftIconTitle={<AiOutlineWarning color="#F79009" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.WARNING}
      textCancel={translate("cancel")}
      textSubmit={translate("submit")}
      submit={() => onSubmit(bookingIds)}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.reviewModalContainer}>
          <div data-cy="confirmationModalWarningBody" className={classes.descriptionModalConfirm}>
            <span>{translate("areYouSureYouWantToReSubmitTheSelectedBookings")}</span>
            <span className="warning">
              {translate("theBookingFileWillBeSentWithAUpdateStatus")}
            </span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(SendBookingFileConfirmationModal);
